
    import './styles.scoped.css';
    export default {
  "root": "_root_14p58_3",
  "tools": "_tools_14p58_11",
  "tools-filtering": "_tools-filtering_14p58_16",
  "tools-filtering-content": "_tools-filtering-content_14p58_20",
  "tools-align-right": "_tools-align-right_14p58_23",
  "tools-pagination": "_tools-pagination_14p58_27",
  "tools-preferences": "_tools-preferences_14p58_27",
  "tools-small": "_tools-small_14p58_33",
  "table": "_table_14p58_39",
  "wrapper": "_wrapper_14p58_44",
  "cell": "_cell_14p58_49",
  "header-cell": "_header-cell_14p58_57",
  "body-cell": "_body-cell_14p58_75",
  "row": "_row_14p58_88",
  "row-selected": "_row-selected_14p58_91",
  "cell-merged": "_cell-merged_14p58_106",
  "cell-merged-content": "_cell-merged-content_14p58_110",
  "empty": "_empty_14p58_117",
  "loading": "_loading_14p58_121",
  "selection-control": "_selection-control_14p58_125"
};
  